import { CANDY_APPLE_DARK, MARIGOLD } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SensitiveScopeGroupWarningIcon = ({
  iconClassName,
  highlySensitive = false
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: highlySensitive ? 'developer-experience-shared-components.scopes.highlySensitiveTooltip' : 'developer-experience-shared-components.scopes.sensitiveTooltip'
    }),
    children: /*#__PURE__*/_jsx(UIIcon, {
      className: iconClassName,
      name: "warning",
      size: 16,
      color: highlySensitive ? CANDY_APPLE_DARK : MARIGOLD
    })
  });
};
export default SensitiveScopeGroupWarningIcon;